export function formatTwoDigit(number: number): string {
	if (number < 0) {
		return `${number}`;
	}

	if (number >= 10) {
		return `${number}`;
	}

	return `0${number}`;
}
